// VARIABLES
const sectionWrapper = document.getElementById("section-wrapper");

// data from attributes
const clear_cart = sectionWrapper.dataset.clearCart === "true";
const product_id = sectionWrapper.dataset.productId;
const product_price = sectionWrapper.dataset.price;
let build_a_box_data = null;

// SECTION BLOCKS
document.addEventListener("DOMContentLoaded", () => {
  // GUARANTEE POPUP BLOCK
  const guarantee_popup_open_button = document.getElementById("block-guarantee-popup-open-button");
  const guarantee_popup_wrapper = document.getElementById("block-guarantee-popup-wrapper");
  const guarantee_popup_close_button = document.getElementById("block-guarantee-popup-close-button");

  if (guarantee_popup_open_button && guarantee_popup_wrapper) {
    guarantee_popup_open_button.addEventListener("click", () => {
      guarantee_popup_wrapper.classList.remove("hidden");
    });
  }

  if (guarantee_popup_close_button && guarantee_popup_wrapper) {
    guarantee_popup_close_button.addEventListener("click", () => {
      guarantee_popup_wrapper.classList.add("hidden");
    });
  }

  // COLOR PICKER SLIDER
  (function () {
    const el = document.querySelector(".color-list-slider-wrapper");
    if (!el) return;

    const bar = document.querySelector(".color-list-scrollbar");
    const track = bar.querySelector(".track");
    const thumb = bar.querySelector(".thumb");

    let isDown = false;
    let startX = 0;
    let startScrollLeft = 0;

    let velocity = 0;
    let lastX = 0;
    let lastTime = 0;
    let rafId = 0;
    let momentumRunning = false;

    const stopMomentum = () => {
      momentumRunning = false;
      cancelAnimationFrame(rafId);
    };

    const momentum = () => {
      momentumRunning = true;

      if (Math.abs(velocity) < 0.01) {
        momentumRunning = false;
        return;
      }
      el.scrollLeft -= velocity * 12;
      velocity *= 0.95;

      updateThumb();
      rafId = requestAnimationFrame(momentum);
    };

    el.addEventListener("dragstart", (e) => e.preventDefault());

    el.addEventListener("mousedown", (e) => {
      if (e.button !== 0) return;
      isDown = true;
      el.classList.add("grabbing");

      bar.classList.add("active");

      startX = e.clientX;
      startScrollLeft = el.scrollLeft;
      velocity = 0;
      lastX = e.clientX;
      lastTime = Date.now();
      stopMomentum();
    });

    window.addEventListener(
      "mousemove",
      (e) => {
        if (!isDown) return;
        e.preventDefault();
        const dx = e.clientX - startX;
        el.scrollLeft = startScrollLeft - dx;

        const now = Date.now();
        const dt = now - lastTime;
        if (dt > 0) velocity = (e.clientX - lastX) / dt;
        lastX = e.clientX;
        lastTime = now;

        updateThumb();
      },
      { passive: false }
    );

    const endDrag = () => {
      if (!isDown) return;
      isDown = false;
      el.classList.remove("grabbing");

      setTimeout(() => bar.classList.remove("active"), 120);

      if (Math.abs(velocity) > 0.08) momentum();
    };

    window.addEventListener("mouseup", endDrag);
    el.addEventListener("mouseleave", endDrag);

    function updateThumb() {
      const cw = el.clientWidth;
      const sw = el.scrollWidth;
      const sl = el.scrollLeft;

      if (sw <= cw) {
        thumb.style.width = "0px";
        thumb.style.transform = "translateX(0)";
        return;
      }

      const trackW = track.clientWidth;
      const minThumb = 40;
      const thumbW = Math.max((cw / sw) * trackW, minThumb);
      const maxLeft = trackW - thumbW;
      const left = (sl / (sw - cw)) * maxLeft;

      thumb.style.width = thumbW + "px";
      thumb.style.transform = `translateX(${left}px)`;
    }

    function syncBarWidth() {
      //const rect = el.getBoundingClientRect();
      //bar.style.width = rect.width + 'px';
      updateThumb();
    }

    el.addEventListener(
      "scroll",
      () => {
        updateThumb();
      },
      { passive: true }
    );

    window.addEventListener("resize", syncBarWidth);

    if (typeof ResizeObserver !== "undefined") {
      const ro = new ResizeObserver(() => syncBarWidth());
      ro.observe(el);
      ro.observe(track);
    } else {
      setTimeout(syncBarWidth, 60);
    }

    syncBarWidth();
    setTimeout(syncBarWidth, 250);
  })();

  // CLEAR CART
  if (clear_cart) {
    fetch("/cart.js", { cache: "no-store" })
      .then((res) => res.json())
      .then((cart) => {
        if (!cart.items || cart.items.length === 0) {
          return;
        }

        const updates = {};

        cart.items.forEach((item) => {
          updates[item.key] = 0;
        });

        return fetch("/cart/update.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ updates }),
        });
      })
      .catch((err) => console.error("Error:", err));
  }

  // TWO VIDEO BLOCK
  const two_video_block_button_1 = document.getElementById("two-video-block-button-1");
  const two_video_block_button_2 = document.getElementById("two-video-block-button-2");
  const two_video_block_video_1 = document.getElementById("two-video-block-video-1");
  const two_video_block_video_2 = document.getElementById("two-video-block-video-2");

  if (two_video_block_button_1 && two_video_block_button_2 && two_video_block_video_1 && two_video_block_video_2) {
    two_video_block_button_1.addEventListener("click", () => {
      two_video_block_video_1.classList.remove("hidden");
      two_video_block_video_2.classList.add("hidden");
      two_video_block_button_1.style.borderBottom = "thin solid #211912";
      two_video_block_button_2.style.borderBottom = "none";
    });

    two_video_block_button_2.addEventListener("click", () => {
      two_video_block_video_1.classList.add("hidden");
      two_video_block_video_2.classList.remove("hidden");
      two_video_block_button_1.style.borderBottom = "none";
      two_video_block_button_2.style.borderBottom = "thin solid #211912";
    });
  }
});

fetch("https://api.skio.com/storefront-http/get-dynamic-box", {
  method: "POST",
  headers: { "Content-Type": "application/json" },
  body: JSON.stringify({ productPlatformId: product_id }),
})
  .then((response) => response.json())
  .then((data) => {
    build_a_box_data = data;
    //console.log('Build a box data ----------------------', build_a_box_data);

    // OPEN / CLOSE NAIL PICKER
    const hidden_overlay = document.getElementById("hidden-overlay");
    const content_wrapper = document.getElementById("content-wrapper");
    const nail_picker_wrapper = document.getElementById("nail-picker-wrapper");
    const pick_your_colors_button = document.getElementById("pick-your-colors-button");
    const pick_your_colors_button_price = pick_your_colors_button.querySelector(".price");
    const pick_your_colors_button_compare_price = pick_your_colors_button.querySelector(".compare-price");
    const nail_picker_close_button = document.getElementById("nail-picker-close-button");
    const upsells_wrapper = document.getElementById("upsells-wrapper");

    // VARIANT PICKER
    const variant_picker_items = document.querySelectorAll(".variant-picker-item");
    let selected_number_of_wraps = 0;
    let max_number_of_wraps = 0;
    let min_number_of_wraps = 10;
    let current_number_of_wraps = 0;
    const build_a_box_id = build_a_box_data.DynamicBox.boxId;
    const selling_plans_data = build_a_box_data.DynamicBox.sellingPlanGroup;

    const selling_plans_ids = Object.entries(selling_plans_data)
      .sort(([, a], [, b]) => a.position - b.position)
      .map(([key, value]) => ({
        id: key.split("/").pop(),
        discount: value.priceAdjustmentAmount,
      }));

    const picker_message_button = document.querySelector(".picker-message-button");
    const picker_continue_button = document.querySelector(".picker-continue-button");
    const build_a_box_gift_items = document.querySelectorAll(".build-a-box-gift-item");
    const gift_items_on_picker = document.querySelectorAll(".nail-picker-gift-item");
    const color_items = document.querySelectorAll(".nail-picker-color");

    // ADD COLOR ITEM BUTTONS
    const add_color_item_buttons = document.querySelectorAll(".add-color-item-button");
    const color_items_count_plus = document.querySelectorAll(".color-item-count-plus");

    const subscription_percent_element = document.getElementById("subscription-percent");
    const subscription_wraps_number_element = document.getElementById("subscription-wraps-number");
    const subscription_term_element = document.getElementById("subscription-term");
    const subscription_price_per_wrap_element = document.getElementById("subscription-price-per-wrap");

    const subscription_picker_first_item = document.querySelector(".subscription-picker-first-item");

    const nail_picker_header_wraps_number_element = document.getElementById("nail-picker-header-wraps-number");

    const selected_colors_array = [];

    const price_per_wrap_elements = document.querySelectorAll(".price-per-wrap");
    const variant_price_elements = document.querySelectorAll(".variant-price");
    const discount_percentage_elements = document.querySelectorAll(".discount-percentage");
    const price_block_loader_element = document.querySelector(".price-block-loader");
    const price_block_content_elements = document.querySelectorAll(".price-block-content");
    const price_block_elements = document.querySelectorAll(".price-block");

    const variant_message_element = document.getElementById("variant-message");

    const variant_picker_items_element = document.getElementById("variant-picker-items");
    const pre_selected_variant_number = variant_picker_items_element.dataset.preSelectedVariantNumber;

    const nail_picker_title_wraps_number = document.getElementById("nail-picker-title-wraps-number");

    const nail_picker_selected_colors = document.querySelectorAll(".nail-picker-selected-color");
    const color_list_selected_colors = document.querySelectorAll(".color-list-selected-color");

    const picker_back_text_button = document.getElementById("picker-back-text-button");

    const picker_continue = document.getElementById("picker-continue-button");
    picker_continue.addEventListener("click", () => {
      goToUpsells();
    });

    variant_picker_items.forEach((item, i, arr) => {
      const number_of_wraps = parseInt(item.dataset.numberOfWraps);
      const subscription_percent = parseInt(item.dataset.subscriptionPercent);
      const subscription_term = parseInt(item.dataset.subscriptionTerm);
      const message = item.dataset.message;

      const per_set_price =
        Math.round(((product_price - (product_price * subscription_percent) / 100) / 100) * 100) / 100;

      price_per_wrap_elements[i].textContent = per_set_price;
      variant_price_elements[i].textContent = (per_set_price * number_of_wraps).toFixed(2);
      discount_percentage_elements[i].textContent = subscription_percent;

      // set the max number of wraps and the price per wrap
      if (number_of_wraps > max_number_of_wraps) {
        max_number_of_wraps = number_of_wraps;
        max_per_set = per_set_price;
      }

      // set the min number of wraps
      if (number_of_wraps < min_number_of_wraps) {
        min_number_of_wraps = number_of_wraps;
      }

      if (i === 0) {
        subscription_percent_element.textContent = subscription_percent;
        subscription_wraps_number_element.textContent = number_of_wraps;
        subscription_term_element.textContent = subscription_term;
        subscription_price_per_wrap_element.textContent = per_set_price;

        subscription_picker_first_item.classList.remove("opacity-0");

        pick_your_colors_button_price.textContent = (per_set_price * number_of_wraps).toFixed(2);
        pick_your_colors_button_compare_price.textContent = ((product_price * number_of_wraps) / 100).toFixed(2);

        selected_number_of_wraps = number_of_wraps;
      }

      // add event listener to the variant picker item
      item.addEventListener("click", () => {
        current_number_of_wraps = number_of_wraps;

        if (selected_colors_array.length > number_of_wraps) {
          selected_colors_array.length = number_of_wraps;
        }

        selected_colors_array.forEach((item) => {
          color_items.forEach((color) => {
            const id = color.dataset.variantId;

            if (id === item) {
              const color_count = checkSelectedColor(id);

              if (color_count === 0) {
                color.querySelector(".quantity-color-item-wrapper").classList.add("hidden");
              }

              const color_item_count = color.querySelector(".color-item-count");
              color_item_count.textContent = color_count;
            }
          });
        });

        // set the wraps number in the selected colors title
        nail_picker_title_wraps_number.textContent = number_of_wraps;

        // set selected colors styles
        nail_picker_selected_colors.forEach((color, index) => {
          const lock_icon = color.querySelector(".lock-icon");
          const plus_icon = color.querySelector("span");
          const image = color.querySelector("img");
          const image_wrapper = color.firstElementChild;
          const remove_icon = color.querySelector(".remove-selected-color");
          const default_title = color.dataset.defaultTitle;
          const color_name = color.querySelector("p");

          if (index > number_of_wraps - 1) {
            lock_icon.classList.remove("hidden");
            plus_icon.classList.add("hidden");
            image.classList.add("hidden");
            image.removeAttribute("src");
            remove_icon.classList.add("hidden");
            color_name.textContent = default_title;
            color.removeAttribute("data-id");

            image_wrapper.style.backgroundColor = "#FAF7F5";
            image_wrapper.style.borderColor = "#2119124D";
          } else {
            lock_icon.classList.add("hidden");
            if (!image.src) {
              plus_icon.classList.remove("hidden");
            }

            image_wrapper.style.backgroundColor = "#ffffff";
            image_wrapper.style.borderColor = "#211912B2";
          }

          const free_label = color.querySelector(".nail-picker-selected-color-free-label");
          switch (number_of_wraps) {
            case 8:
              if (index > 3) {
                free_label.style.display = "block";
              } else {
                free_label.style.display = "none";
              }
              break;
            case 6:
              if (index === 3 || index === 4 || index === 5) {
                free_label.style.display = "block";
              } else {
                free_label.style.display = "none";
              }
              break;
            case 4:
              if (index === 2 || index === 3) {
                free_label.style.display = "block";
              } else {
                free_label.style.display = "none";
              }
              break;
          }
        });

        // set selected colors styles on picker
        color_list_selected_colors.forEach((color, index) => {
          const lock_icon = color.querySelector(".lock-icon");
          const plus_icon = color.querySelector("span");
          const image = color.querySelector("img");

          if (index > number_of_wraps - 1) {
            lock_icon.classList.remove("hidden");
            plus_icon.classList.add("hidden");
            image.classList.add("hidden");
            image.removeAttribute("src");
            color.removeAttribute("data-id");

            color.style.backgroundColor = "#FAF7F5";
            color.style.borderColor = "#2119124D";
          } else {
            lock_icon.classList.add("hidden");
            if (!image.src) {
              plus_icon.classList.remove("hidden");
            }

            color.style.backgroundColor = "#ffffff";
            color.style.borderColor = "#211912B2";
          }
        });

        // hide and show the price block
        price_block_elements.forEach((element) => {
          element.style.display = "none";
        });
        price_block_elements[i].style.display = "block";

        // set the message for the variant
        variant_message_element.textContent = message;

        selected_number_of_wraps = number_of_wraps;

        picker_message_button.classList.remove("hidden");
        picker_message_button.textContent = `SELECT ${selected_number_of_wraps} MORE COLOURS`;
        picker_continue_button.classList.add("hidden");
        showAddColorItemButtons();

        nail_picker_header_wraps_number_element.textContent = number_of_wraps;

        pick_your_colors_button_price.textContent = (per_set_price * number_of_wraps).toFixed(2);
        pick_your_colors_button_compare_price.textContent = ((product_price * number_of_wraps) / 100).toFixed(2);

        subscription_percent_element.textContent = subscription_percent;
        subscription_wraps_number_element.textContent = number_of_wraps;
        subscription_term_element.textContent = subscription_term;
        subscription_price_per_wrap_element.textContent = per_set_price;

        arr.forEach((item, i) => {
          item.classList.remove("active");
        });

        item.classList.add("active");

        build_a_box_gift_items.forEach((gift_item) => {
          const variant_name = parseInt(gift_item.dataset.variantName);
          const image = gift_item.querySelector("img");

          if (variant_name > number_of_wraps) {
            image.classList.add("hidden");
          } else {
            image.classList.remove("hidden");
          }
        });

        gift_items_on_picker.forEach((gift_item) => {
          const variant_name = parseInt(gift_item.dataset.variantName);
          const image = gift_item.querySelector("img");

          if (variant_name > number_of_wraps) {
            image.classList.add("hidden");
          } else {
            image.classList.remove("hidden");
          }
        });

        if (selected_colors_array.length === number_of_wraps) {
          hideAddColorItemButtons();
        } else {
          showAddColorItemButtons();
        }
      });
    });

    price_block_loader_element.classList.add("hidden");
    price_block_content_elements.forEach((element) => {
      element.classList.remove("hidden");
      element.classList.add("flex");
    });

    variant_picker_items[pre_selected_variant_number - 1].click();

    const nail_picker_color_list_wrapper = document.getElementById("nail-picker-color-list-wrapper");
    nail_picker_selected_colors.forEach((color) => {
      color.addEventListener("click", () => {
        hidden_overlay.classList.remove("hidden");
        document.body.style.overflow = "hidden";

        nail_picker_color_list_wrapper.classList.remove("hidden");
      });
    });

    const nail_picker_color_list_close_popup = document.querySelectorAll(".nail-picker-color-list-close-popup");
    nail_picker_color_list_close_popup.forEach((item) => {
      item.addEventListener("click", () => {
        hidden_overlay.classList.add("hidden");
        document.body.style.overflow = "auto";

        nail_picker_color_list_wrapper.classList.add("hidden");
      });
    });

    if (content_wrapper && nail_picker_wrapper && pick_your_colors_button) {
      pick_your_colors_button.addEventListener("click", () => {
        hidden_overlay.classList.remove("hidden");
        document.body.style.overflow = "hidden";

        nail_picker_color_list_wrapper.classList.remove("hidden");
      });

      nail_picker_close_button.addEventListener("click", () => {
        hidden_overlay.classList.add("hidden");
        document.body.style.overflow = "auto";

        nail_picker_color_list_wrapper.classList.remove("hidden");
      });

      pick_your_colors_button.querySelector(".loader").classList.add("hidden");
      pick_your_colors_button.querySelector(".text").classList.remove("hidden");
    }

    const guarantee_popup_open_button = document.getElementById("guarantee-popup-open-button");
    const guarantee_popup_content = document.getElementById("guarantee-popup-content");
    const guarantee_popup_close_buttons = document.querySelectorAll(".guarantee-popup-close-button");

    if (guarantee_popup_open_button && guarantee_popup_content) {
      guarantee_popup_open_button.addEventListener("click", () => {
        guarantee_popup_content.classList.remove("hidden");
      });
    }

    if (guarantee_popup_close_buttons && guarantee_popup_content) {
      guarantee_popup_close_buttons.forEach((item) => {
        item.addEventListener("click", () => {
          guarantee_popup_content.classList.add("hidden");
        });
      });
    }
    // NAIL PICKER INITIAL DATA
    const selectable_product_variants = build_a_box_data.DynamicBox.selectableProductVariants;
    const productIds = selectable_product_variants.map((p) =>
      p.productPlatformId.replace("gid://shopify/Product/", "")
    );

    // hide products from collection that are not in the build a box
    color_items.forEach((item) => {
      const product_id = item.dataset.id;

      if (!productIds.includes(product_id)) {
        item.classList.add("hidden");
      }
    });

    // KEENSLIDER
    function ThumbnailPlugin(main) {
      return (slider) => {
        function removeActive() {
          slider.slides.forEach((slide) => {
            slide.classList.remove("active");
          });
        }

        function addActive(idx) {
          slider.slides[idx].classList.add("active");
        }

        function addClickEvents() {
          slider.slides.forEach((slide, idx) => {
            slide.addEventListener("click", () => {
              main.moveToIdx(idx);
            });
          });
        }

        const leftButton = document.getElementById("keen-large-slider-left");
        const rightButton = document.getElementById("keen-large-slider-right");

        rightButton.addEventListener("click", () => {
          if (!slider.track.details.atEnd) {
            main.next();
          }
        });

        leftButton.addEventListener("click", () => {
          if (!slider.track.details.atStart) {
            main.prev();
          }
        });

        slider.on("created", () => {
          addActive(slider.track.details.rel);
          addClickEvents();
          main.on("animationStarted", (main) => {
            removeActive();
            const next = main.animator.targetIdx || 0;
            addActive(main.track.absToRel(next));
            slider.moveToIdx(Math.min(slider.track.details.maxIdx, next));
          });
        });
      };
    }

    const product_large_slider = new KeenSlider("#product-keen-large-slider", {
      loop: false,
      slides: {
        spacing: 0,
        perView: 1,
      },
      created: () => {
        const slides = sectionWrapper.querySelectorAll(".keen-slider__slide");
        slides.forEach((slide) => {
          slide.classList.remove("hidden");
        });
      },
    });

    const product_thumbnails_slider = new KeenSlider(
      "#product-keen-thumbnail-slider",
      {
        loop: false,
        slides: {
          spacing: 10,
          perView: 6,
        },
        vertical: false,
      },
      [ThumbnailPlugin(product_large_slider)]
    );

    // CHECK SELECTED COLOR COUNT
    function checkSelectedColor(data_id) {
      return selected_colors_array.filter((id) => id === data_id).length;
    }

    function addProduct(data_id, data_title, data_image) {
      selected_colors_array.push(data_id);
      //checkGiftsItems();

      for (const color of nail_picker_selected_colors) {
        const image = color.querySelector("img");
        if (!image.src) {
          image.src = data_image;
          image.classList.remove("hidden");
          color.querySelector("p").textContent = data_title;
          color.querySelector("span").classList.add("hidden");
          color.querySelector(".remove-selected-color").classList.remove("hidden");
          color.setAttribute("data-id", data_id);

          break;
        }
      }

      for (const color of color_list_selected_colors) {
        const image = color.querySelector("img");
        if (!image.src) {
          image.src = data_image;
          image.classList.remove("hidden");
          color.querySelector("span").classList.add("hidden");
          color.setAttribute("data-id", data_id);

          break;
        }
      }
    }

    // ADD COLOR TO PICKER FROM COLOR LIST
    color_items.forEach((color_item) => {
      const add_color_item_button = color_item.querySelector(".add-color-item-button");
      if (add_color_item_button) {
        add_color_item_button.addEventListener("click", () => {
          const current_color = color_item;
          const data_id = current_color.dataset.variantId;
          const data_title = current_color.dataset.title;
          const data_image = current_color.dataset.image;

          if (selected_colors_array.length < current_number_of_wraps) {
            current_color.querySelector(".quantity-color-item-wrapper").classList.remove("hidden");

            addProduct(data_id, data_title, data_image);

            const color_count = checkSelectedColor(data_id);
            const color_item_count = current_color.querySelector(".color-item-count");
            color_item_count.textContent = color_count;

            if (selected_colors_array.length === current_number_of_wraps) {
              hideAddColorItemButtons();
            }
          }
        });
      }

      const add_color_item_button_plus = color_item.querySelector(".color-item-count-plus");
      if (add_color_item_button_plus) {
        add_color_item_button_plus.addEventListener("click", () => {
          const current_color = color_item;
          const data_id = current_color.dataset.variantId;
          const data_title = current_color.dataset.title;
          const data_image = current_color.dataset.image;

          if (selected_colors_array.length < current_number_of_wraps) {
            addProduct(data_id, data_title, data_image);

            const color_count = checkSelectedColor(data_id);
            const color_item_count = current_color.querySelector(".color-item-count");

            if (color_item_count) {
              color_item_count.textContent = color_count;
            }
          }

          if (selected_colors_array.length === current_number_of_wraps) {
            hideAddColorItemButtons();
          }
        });
      }
    });

    // REMOVE BUTTONS ON COLOR ITEMS LIST
    const remove_selected_color_items = document.querySelectorAll(".remove-selected-color-item");
    remove_selected_color_items.forEach((item) => {
      item.addEventListener("click", (event) => {
        event.stopPropagation();
        const current_item = event.currentTarget;
        const parent = current_item.closest(".nail-picker-color");
        const data_id = current_item.dataset.id;

        selected_colors_array.splice(selected_colors_array.indexOf(data_id), 1);

        if (checkSelectedColor(data_id) === 0) {
          parent.querySelector(".quantity-color-item-wrapper").classList.add("hidden");
        }

        const color_item_count = parent.querySelector(".color-item-count");
        const color_count = checkSelectedColor(data_id);
        color_item_count.textContent = color_count;

        const nail_picker_selected_colors_reversed = [...nail_picker_selected_colors].reverse();
        for (const color of nail_picker_selected_colors_reversed) {
          const id = color.dataset.id;
          const default_title = color.dataset.defaultTitle;

          if (id === data_id) {
            const image = color.querySelector("img");
            image.removeAttribute("src");
            image.classList.add("hidden");

            color.removeAttribute("data-id");

            color.querySelector("p").textContent = default_title;
            color.querySelector("span").classList.remove("hidden");
            color.querySelector(".remove-selected-color").classList.add("hidden");

            break;
          }
        }

        const color_list_selected_colors_reversed = [...color_list_selected_colors].reverse();
        for (const color of color_list_selected_colors_reversed) {
          const id = color.dataset.id;

          if (id === data_id) {
            const image = color.querySelector("img");
            image.removeAttribute("src");
            image.classList.add("hidden");

            color.removeAttribute("data-id");

            color.querySelector("span").classList.remove("hidden");

            break;
          }
        }

        showAddColorItemButtons();
      });
    });

    // REMOVER FROM SELECTED COLORS
    const remove_selected_colors = document.querySelectorAll(".remove-selected-color");
    remove_selected_colors.forEach((item, index) => {
      item.addEventListener("click", (event) => {
        event.stopPropagation();
        const current_item = event.currentTarget;
        const parent = current_item.closest(".nail-picker-selected-color");
        const data_id = parent.dataset.id;

        selected_colors_array.splice(selected_colors_array.indexOf(data_id), 1);

        for (const color of color_items) {
          const id = color.dataset.variantId;

          if (id === data_id) {
            const color_count = checkSelectedColor(data_id);

            if (color_count === 0) {
              color.querySelector(".quantity-color-item-wrapper").classList.add("hidden");
            }

            const color_item_count = color.querySelector(".color-item-count");
            color_item_count.textContent = color_count;

            break;
          }
        }

        const current_color_for_remove = nail_picker_selected_colors[index];
        const default_title = current_color_for_remove.dataset.defaultTitle;
        current_color_for_remove.removeAttribute("data-id");
        current_color_for_remove.querySelector("img").removeAttribute("src");
        current_color_for_remove.querySelector("img").classList.add("hidden");
        current_color_for_remove.querySelector("p").textContent = default_title;
        current_color_for_remove.querySelector("span").classList.remove("hidden");
        current_color_for_remove.querySelector(".remove-selected-color").classList.add("hidden");

        const current_picker_color_for_remove = color_list_selected_colors[index];
        current_picker_color_for_remove.removeAttribute("data-id");
        current_picker_color_for_remove.querySelector("img").removeAttribute("src");
        current_picker_color_for_remove.querySelector("img").classList.add("hidden");
        current_picker_color_for_remove.querySelector("span").classList.remove("hidden");

        showAddColorItemButtons();
      });
    });

    // HIDE ADD COLOR ITEM BUTTONS
    function hideAddColorItemButtons() {
      // HIDE ADD COLOR ITEM BUTTONS
      add_color_item_buttons.forEach((button) => {
        button.classList.add("hidden");
      });

      // DISABLE COLOR ITEM COUNT PLUS BUTTONS
      color_items_count_plus.forEach((button) => {
        button.style.opacity = "0";
        button.style.cursor = "default";
      });

      picker_back_text_button.classList.add("hidden");
      picker_continue.classList.remove("hidden");
    }

    // SHOW ADD COLOR ITEM BUTTONS
    function showAddColorItemButtons() {
      // SHOW ADD COLOR ITEM BUTTONS
      add_color_item_buttons.forEach((button) => {
        button.classList.remove("hidden");
      });

      // ENABLE COLOR ITEM COUNT PLUS BUTTONS
      color_items_count_plus.forEach((button) => {
        button.style.opacity = "1";
        button.style.cursor = "pointer";
      });

      picker_back_text_button.classList.remove("hidden");
      picker_continue.classList.add("hidden");
    }

    // UPSSELLS OPEN / CLOSE BUTTONS
    const upsells_close_button = document.getElementById("upsells-close-button");

    let build_box_price = 0;
    let build_box_compare_price = 0;

    let upsells_products_prices = 0;
    let upsells_products_compare_prices = 0;

    const upsells_checkout_button = document.getElementById("upsells-checkout-button");
    const upsells_checkout_button_price = upsells_checkout_button.querySelector(".price");
    const upsells_checkout_button_compare_price = upsells_checkout_button.querySelector(".compare-price");

    function goToUpsells() {
      nail_picker_color_list_wrapper.classList.add("hidden");

      upsells_wrapper.classList.remove("hidden");
      upsells_wrapper.scrollTo(0, 0);

      let selected_selling_plan_discount = 0;
      switch (selected_colors_array.length) {
        case 4:
          selected_selling_plan_discount = selling_plans_ids[2].discount;
          break;
        case 6:
          selected_selling_plan_discount = selling_plans_ids[1].discount;
          break;
        case 8:
          selected_selling_plan_discount = selling_plans_ids[0].discount;
          break;
      }

      const per_set_price = Math.round(
        ((product_price - (product_price * selected_selling_plan_discount) / 100) / 100) * 100
      );

      build_box_price = per_set_price * selected_colors_array.length;
      // build_box_price = total_full_price - parseFloat(total_full_price * selected_selling_plan_discount / 100) - parseFloat(discount_tiers[selected_colors_array.length]) * 100;
      build_box_compare_price = parseFloat(product_price) * selected_colors_array.length;

      upsells_checkout_button_price.textContent = (build_box_price / 100 + upsells_products_prices / 100).toFixed(2);
      upsells_checkout_button_compare_price.textContent = (
        build_box_compare_price / 100 +
        upsells_products_compare_prices / 100
      ).toFixed(2);
    }

    upsells_close_button.addEventListener("click", () => {
      upsells_wrapper.classList.add("hidden");

      hidden_overlay.classList.add("hidden");
      document.body.style.overflow = "auto";
    });

    // RATING REVIEWS COUNT
    function ratingReviewsCount() {
      const productRatings = document.querySelectorAll(".collection-product-rating");
      productRatings.forEach((rating) => {
        const html = rating.innerHTML;
        const reviews = html.split('data-number-of-reviews="')[1].split('"')[0];

        if (+reviews > 0) {
          rating.querySelector(".collection-product-rating-reviews-count").textContent = `(${reviews})`;
        }
      });
    }

    ratingReviewsCount();

    // UPSSELLS ADD BUTTON
    const upsells_products_array = [];
    const upsells_add_buttons = document.querySelectorAll(".upsells-add-button");
    //const upsells_quantity_buttons = document.querySelectorAll('.upsells-quantity-buttons');
    const remove_upsells_colors = document.querySelectorAll(".remove-upsells-color");
    const upsells_color_item_count_plus = document.querySelectorAll(".upsells-color-item-count-plus");

    upsells_add_buttons.forEach((button) => {
      button.addEventListener("click", (event) => {
        const current_button = event.currentTarget;
        const data_variant_id = current_button.dataset.variantId;
        const data_price = parseInt(current_button.dataset.price);
        const data_compare_price = parseInt(current_button.dataset.comparePrice);

        upsells_products_array.push(data_variant_id);
        upsells_products_prices += data_price;
        upsells_products_compare_prices += data_compare_price;

        upsells_checkout_button_price.textContent = (build_box_price / 100 + upsells_products_prices / 100).toFixed(2);
        upsells_checkout_button_compare_price.textContent = (
          build_box_compare_price / 100 +
          upsells_products_compare_prices / 100
        ).toFixed(2);

        current_button.classList.add("hidden");
        const next_upsells_quantity_button = current_button.nextElementSibling;
        next_upsells_quantity_button.classList.remove("hidden");
        next_upsells_quantity_button.classList.add("flex");

        const quntity = next_upsells_quantity_button.querySelector(".upsells-color-item-count");
        quntity.textContent = 1;
      });
    });

    function getUpsellProductCount(data_variant_id) {
      return upsells_products_array.filter((id) => id === data_variant_id).length;
    }

    remove_upsells_colors.forEach((button) => {
      button.addEventListener("click", (event) => {
        const current_button = event.currentTarget;
        const data_variant_id = current_button.dataset.variantId;
        const data_price = parseInt(current_button.dataset.price);
        const data_compare_price = parseInt(current_button.dataset.comparePrice);

        upsells_products_array.splice(upsells_products_array.indexOf(data_variant_id), 1);
        upsells_products_prices -= data_price;
        upsells_products_compare_prices -= data_compare_price;

        upsells_checkout_button_price.textContent = (upsells_products_prices / 100 + build_box_price / 100).toFixed(2);
        upsells_checkout_button_compare_price.textContent = (
          upsells_products_compare_prices / 100 +
          build_box_compare_price / 100
        ).toFixed(2);

        const quntity = getUpsellProductCount(data_variant_id);
        const quantity_element = current_button.nextElementSibling;
        quantity_element.textContent = quntity;

        if (quntity === 0) {
          const quantity_wrapper = current_button.parentElement;
          quantity_wrapper.classList.add("hidden");
          const next_upsells_quantity_button = quantity_wrapper.previousElementSibling;
          next_upsells_quantity_button.classList.remove("hidden");
          next_upsells_quantity_button.classList.add("flex");
        }
      });
    });

    upsells_color_item_count_plus.forEach((button) => {
      button.addEventListener("click", (event) => {
        const current_button = event.currentTarget;
        const data_variant_id = current_button.dataset.variantId;
        const data_price = parseInt(current_button.dataset.price);
        const data_compare_price = parseInt(current_button.dataset.comparePrice);

        upsells_products_array.push(data_variant_id);
        upsells_products_prices += data_price;
        upsells_products_compare_prices += data_compare_price;

        upsells_checkout_button_price.textContent = (upsells_products_prices / 100 + build_box_price / 100).toFixed(2);
        upsells_checkout_button_compare_price.textContent = (
          upsells_products_compare_prices / 100 +
          build_box_compare_price / 100
        ).toFixed(2);

        const quntity = getUpsellProductCount(data_variant_id);
        const quantity_element = current_button.previousElementSibling;
        quantity_element.textContent = quntity;
      });
    });

    // UPSSELLS CHECKOUT BUTTON
    upsells_checkout_button.addEventListener("click", () => {
      const text = upsells_checkout_button.querySelector(".text");
      const loader = upsells_checkout_button.querySelector(".loader");

      text.classList.add("hidden");
      loader.classList.remove("hidden");

      const gift_products_ids = [];
      gift_items_on_picker.forEach((item) => {
        const img = item.querySelector("img");

        if (!img.classList.contains("hidden")) {
          const id = item.dataset.id;
          gift_products_ids.push(id);
        }
      });

      const productCount = {};

      selected_colors_array.forEach((id) => {
        if (productCount[id]) {
          productCount[id]++;
        } else {
          productCount[id] = 1;
        }
      });

      let selected_selling_plan_id = null;

      switch (selected_colors_array.length) {
        case 4:
          selected_selling_plan_id = selling_plans_ids[2].id;
          break;
        case 6:
          selected_selling_plan_id = selling_plans_ids[1].id;
          break;
        case 8:
          selected_selling_plan_id = selling_plans_ids[0].id;
          break;
      }

      const payload = {
        items: [
          ...selected_colors_array.map((id, i) => ({
            id: id,
            quantity: 1,
            ...(selected_selling_plan_id && {
              selling_plan: selected_selling_plan_id,
            }),
            properties: {
              _dynamicBoxIndex: 0,
              _dynamicBoxId: build_a_box_id,
            },
          })),
          ...upsells_products_array.map((id) => ({
            id: id,
            quantity: 1,
            properties: {
              Upsell: "✓",
            },
          })),
          ...gift_products_ids.map((id) => ({
            id: id,
            quantity: 1,
            properties: {
              Gift: "✓",
            },
          })),
        ],
      };

      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      })
        .then((res) => res.json())
        .then((data) => {
          console.log("✅ Successfully added to cart:", data);

          text.classList.remove("hidden");
          loader.classList.add("hidden");

          window.location.href = "/checkout";
        })
        .catch((err) => console.error("❌ Error adding to cart:", err));
      //}
    });
  })
  .catch((error) => console.error("Ошибка:", error));
